import { useEffect } from "react";
import { useParams } from "react-router-dom";

const Page = (props) => {
    const { id } = useParams();
    useEffect(() => {
        document.title = `Hazardous Waste Tracking System${props.title ? (": " + props.title) : ""}${id ? " " + id : ""}`;
    }, [props.title]);
    return props.children;
};

export default Page;